import { translate } from '../../../../i18n';
import { getSiblingsLotteryResultReferenceFlag } from '../../../../containers/common/codeMaster'
import { AttentionLabel } from '../../common/attentionLabel';
import { GItem } from '../../common/grids';
import { RadioButtonGroup } from '../../common/inputs/radioButtonGroup';
import { TitleLabel } from '../../common/titleLabel';

export interface SiblingsLotteryResultReferenceFlagFieldProps {
    childNum: number
    required: boolean
}

const SiblingsLotteryResultReferenceFlagField = (props: SiblingsLotteryResultReferenceFlagFieldProps) => {
    const { childNum, required } = props;

    return (
        <GItem xs={12}>
            <div>
                <TitleLabel>
                    <AttentionLabel>*</AttentionLabel>
                    {translate("facilityReservationForm.form.label.siblingsLotteryResultReferenceFlag")}
                </TitleLabel>
            </div>
            <RadioButtonGroup
                name={`children.${childNum}.siblingsLotteryResultReferenceFlag`}
                label={translate("facilityReservationForm.form.label.siblingsLotteryResultReferenceFlag")}
                row
                required={required}
                buttonValueLabels={getSiblingsLotteryResultReferenceFlag().reverse()}
            />
        </GItem> 
    );
}

export default SiblingsLotteryResultReferenceFlagField;
